import { ModalDirective } from "ngx-bootstrap";
import { ServiceManager } from "../../../service-manager";
import { SearchDirective, SearchColumn } from "../search-utils";
import { IPaginate } from "../../../interfaces/utils.interface";
import { ModalOption } from "../../../helpers/modal-option";
import {
  Component,
  Input,
  ViewChild,
  EventEmitter,
  Output,
  OnDestroy,
  OnInit
} from "@angular/core";
import { Subscription } from "rxjs/internal/Subscription";

@Component({
  selector: "search-template",
  templateUrl: "./search-template.component.html"
})
export class SearchTemplateComponent
  implements OnInit, OnDestroy, SearchDirective, IPaginate {
  private _loadSubscr: Subscription;
  private _service: ServiceManager<any>;

  @Input() showPagination = true;
  @Input() modalSize = "modal-xl";
  @Input()
  set service(value: ServiceManager<any>) {
    this._service = value;

    if (this._service) {
      this._loadSubscr = this._service.loadEmitter.subscribe(args => {});
    }
  }
  get service(): ServiceManager<any> {
    return this._service;
  }
  @Input() titleModal = "Busqueda";
  @Input() filter = true;
  @Input() columns = new Array<SearchColumn>();
  @Input() dataKey = "";
  @Input() pgRowsPerPage = new Array<number>();
  @Input() pgMaxSize = 4;
  @Input() pgBoundaryLinks = true;
  @Input() pgPreviousText = "&lsaquo;";
  @Input() pgNextText = "&rsaquo;";
  @Input() pgFirstText = "&laquo;";
  @Input() pgLastText = "&raquo;";
  @Input() pgShowTotalRows = true;

  @Output() onSearch = new EventEmitter();
  @ViewChild("modal") modal: ModalDirective;

  activeFilter = new SearchColumn();
  config = new ModalOption();

  ngOnInit() {
    if (!this.service.data || this.service.data.length == 0) {
      this.service.add();
      this.service.refresh();
    }
  }

  ngOnDestroy() {
    if (this._loadSubscr) {
      this._loadSubscr.unsubscribe();
    }
  }

  showModal() {
    this.modal.show();
  }

  search() {
    this.service.requestSetting.Filters = [];
    this.service.requestSetting.Filters.push(this.activeFilter.ToFilter());
    this.service.load();
  }

  select(model: any) {
    this.onSearch.emit({ model: model });
    this.modal.hide();
  }

  cancel() {
    this.modal.hide();
  }
}
